import axios from 'axios';
import getAuthToken from '../utils/cookie';
import toast from 'react-hot-toast';

export const getSubmissionsDataApi = async (
  nextPage = null,
  filters = {},
  query_text = '',
  sortBy = null,
  sortOrder = null
) => {
  const tok = getAuthToken();
  const params = {};
  if (nextPage) params.next_page = nextPage;
  if (query_text) params.query_text = query_text?.trim();
  if (filters) params.filters = JSON.stringify(filters);
  if (sortBy) params.sort_by = sortBy;
  if (sortOrder) params.sort_order = sortOrder;

  const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}submission/list/`, {
    headers: { Authorization: `Bearer ${tok}` },
    params
  });
  return response;
};


export const getSubmissionsFilterOptionApi = async () => {
  const tok = getAuthToken();
  const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}submission/filter/options`, {
    headers: { Authorization: `Bearer ${tok}` },
  });
  return response;
};

export const getSubmissionsLongDataApi = async () => {
  let response;
  const tok = getAuthToken();
  try {
    response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}submission/long/polling/`, {
      headers: {
        Authorization: `Bearer ${tok}`
      }
    });
  } catch (err) {
    throw err;
  }

  return response;
};

export const updateSubmissionDataApi = async ({ data }) => {
  let response;
  const tok = getAuthToken();
  try {
    response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}submission/`, data, {
      headers: {
        Authorization: `Bearer ${tok}`
      }
    });
  } catch (err) {
    toast.error(err?.response.data?.error);
  }
};

export const deleteSubmissionDataApi = async ({ submissionId }) => {
  let response;
  const tok = getAuthToken();
  try {
    response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}submission/`, {
      headers: {
        Authorization: `Bearer ${tok}`
      },
      data: { _id: submissionId }
    });
  } catch (err) {
    toast.error(err?.response.data?.error);
  }

  return response;
};

export const downloadSubmissionDataApi = async ({ submissionId }) => {
  let response;
  const tok = getAuthToken();
  try {
    response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}submission/?id=${submissionId}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${tok}`
        }
      }
    );
  } catch (err) {
    toast.error(err?.response.data?.error);
  }

  return response;
};

export const addSubmissionDataApi = async ({ data }) => {
  let response;
  const tok = getAuthToken();
  try {
    response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}submission/`, data, {
      headers: {
        Authorization: `Bearer ${tok}`
      }
    });
  } catch (err) {
    toast.error(err?.response.data?.error);
  }

  return response;
};

export const getDocumentSharingDetails = async (doc_id) => {
  const apiUrl = `${process.env.REACT_APP_BACKEND_URL}submission/sharing/details/?doc_id=${doc_id}`;
  const tok = getAuthToken();
  const response = await axios.get(apiUrl, {
    headers: {
      Authorization: `Bearer ${tok}`
    }
  });
  return response;
};

export const updateDocumentSharingDetails = async (data) => {
  const apiUrl = `${process.env.REACT_APP_BACKEND_URL}submission/sharing/details/`;
  const tok = getAuthToken();
  const response = await axios.put(apiUrl, data, {
    headers: {
      Authorization: `Bearer ${tok}`
    }
  });
  return response;
};

export const getProcessingLogs = async (submissionId) => {
  const tok = getAuthToken();
  const response = await axios.get(
    `${process.env.REACT_APP_BACKEND_URL}v2/logs/${submissionId}/`,
    {
      headers: {
        Authorization: `Bearer ${tok}`
      }
    }
  );
  return response;
};

export const analyzeScriptApi = async (formData) => {
  const tok = getAuthToken();
  const response = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}v2/analyze/`, 
    formData,
    {
      headers: {
        Authorization: `Bearer ${tok}`,
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return response;
};
